<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import EcommerceSetupsForm from './EcommerceSetupsForm.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  perm?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = "/clients/system/company/ecommerce-setups/";
const title = "Ecommerce Setups";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: "outlet", caption: "Outlet", sortable: true, fieldType: "text" },
  { name: "type", caption: "Type", sortable: true, fieldType: "text" },
  { name: "only_selected_items", caption: "Only Selected Items", sortable: true, fieldType: "text" },
  { name: "products_per_page", caption: "Products Per Page", sortable: true, fieldType: "number" },
  { name: "no_of_top_offer_products", caption: "No. of Top Offer Products", sortable: true, fieldType: "number" },
  { name: "no_of_best_selling_products", caption: "No. of Best Selling Products", sortable: true, fieldType: "number" },
  { name: "no_of_new_arrival_products", caption: "No. of New Arrival Products", sortable: true, fieldType: "number" },
  { name: "show_points", caption: "Show Points", sortable: true, fieldType: "checkbox" },
  { name: "show_reviews", caption: "Show Reviews", sortable: true, fieldType: "checkbox" },
  { name: "show_out_of_stock_products", caption: "Show Out of Stock Products", sortable: true, fieldType: "checkbox" },
  { name: "allow_pre_orders", caption: "Allow Pre Orders", sortable: true, fieldType: "checkbox" },
  { name: "active", caption: "Active", sortable: false, fieldType: "status" },
];


const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @permissions="permissions = $event"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton">
  <template #form-view>
    <EcommerceSetupsForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>